import { colors } from './colors';

export const background = {
  disabled: colors.gray['05'],
};
